import React from "react";
import * as S from "../styles";
export var StarIcon = function StarIcon() {
  return React.createElement(S.svg, {
    viewBox: "0 0 25 24",
    width: "17px",
    height: "17px",
    "aria-hidden": "true"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M12.499 0L8.638 7.826 0 9.083 6.25 15.172 4.774 23.774 12.499 19.714 20.225 23.774 18.749 15.172 24.999 9.083 16.363 7.826z"
  }));
};
export default StarIcon;